import React, { CSSProperties, useState } from 'react';
import { Select } from 'tea-component';
import { useIntl } from 'umi';

import './index.scss';

export const RegionType = {
  region: 'region',
  country: 'market',
};

interface IRegionTypeSelectorProps {
  onChange: (type: string) => void;
  defaultValue?: string;
  style?: CSSProperties;
}

function RegionTypeSelector(props: IRegionTypeSelectorProps) {
  const { onChange, defaultValue, style } = props;

  const { formatMessage } = useIntl();

  const [value, setValue] = useState(defaultValue || RegionType.region);

  const options = [
    {
      value: RegionType.region,
      text: formatMessage({ id: 'dbi_by_region' }),
    },
    {
      value: RegionType.country,
      text: formatMessage({ id: 'dbi_by_country' }),
    },
  ];

  const handleChange = (type: string) => {
    setValue(type);
    onChange?.(type);
  };

  return (
    <div className="dbi_region_country_type_selector">
      <Select
        matchButtonWidth
        className="select-item"
        appearance="button"
        style={{ width: 130, ...style }}
        options={options}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default RegionTypeSelector;
